import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { history, apiService } from "_helpers";
import { CenterAddressModal, CenterConfigModal } from "_components";

export { CenterSetting };

function CenterSetting() {
  const { user: authUser } = useSelector((x) => x.auth);
  const dispatch = useDispatch();
  const [centerList, setCenterList] = useState([]);
  const [filteredCenterList, setFilteredCenterList] = useState([]);
  const [doctorList, setDoctorListData] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [modifiedCenters, setModifiedCenters] = useState([]);

  const closeClick = (event) => {
    history.navigate("/home");
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getCenterList(), getDoctorList()]);
    };
    fetchData();
  }, []);

  const getCenterList = async () => {
    if (!authUser) return null;
    const user_key = authUser?.user_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetCenterList?user_key=`+user_key.toString();
    const data = await apiService.get(url, dispatch);
    console.log(data);
    if (Array.isArray(data) && data.length > 0) {
      setCenterList(data);
    }
  };

  const getDoctorList = async () => {
    if (!authUser) return null;
    const user_key = authUser?.user_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetDoctorList?user_key=`+user_key.toString();
    const data = await apiService.get(url, dispatch);
    if (Array.isArray(data) && data.length > 0) {
      setDoctorListData(data);
    }
  };

  const handleEditAddress = (center) => {
    setSelectedCenter(center);
    setShowAddressModal(true);
  };

  const handleEditConfig = (center) => {
    setSelectedCenter(center);
    setShowConfigModal(true);
  };

  const handleModalSave = async (updatedFields, updateType) => {
    if (!selectedCenter) return;
    // Merge updated fields into the selected center
    const updatedCenter = {
      ...selectedCenter,
      ...updatedFields,
      update_type: updateType,
    };
    try {
      const url = `${process.env.REACT_APP_API_URL}/center/UpdateCenterList`;
      // Send only the updated center as an array
      const response = await apiService.post(url, [updatedCenter], dispatch);
      if (response?.success) {
        setSelectedCenter(null);
        setShowConfigModal(false);
        setShowAddressModal(false);
        setCenterList((prevList) =>
          prevList.map((center) =>
            center.center_key === updatedCenter.center_key
              ? { ...center, ...updatedFields }
              : center
          )
        );
        alert("Center updated successfully.");
      } else {
        alert("Failed to update center. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while updating center.");
    }
  };

  const handleSearchChange = (event) => {
    var filterColName = event.target.id;
    var filterColValue = String(event.target.value).toLowerCase();

    if (filterColValue) {
      const filteredData = centerList.filter((center) =>
        String(center[filterColName]).toLowerCase().includes(filterColValue)
      );
      setFilteredCenterList(filteredData);
    } else {
      setFilteredCenterList([]);
    }
  };
  const updateCenter = async (event) => {
    console.log(modifiedCenters);
    if (!Array.isArray(modifiedCenters) || modifiedCenters.length === 0) {
      console.warn("No modified centers to send.");
      alert("No modified centers to send.");
      return;
    }

    try {
      const url = `${process.env.REACT_APP_API_URL}/center/UpdateCenterList`;
      const response = await apiService.post(url, modifiedCenters, dispatch);

      if (response?.success) {
        console.log("Centers updated successfully:", response);
        alert("Center updates saved to database.");
        getCenterList();
        setModifiedCenters([]);
      } else {
        console.error(
          "Failed to update centers:",
          response?.message || response
        );
        alert("Failed to save changes. Please try again.");
      }
    } catch (error) {
      console.error("Error while sending centers to database:", error);
      alert("An unexpected error occurred while saving.");
    }
  };

  const handleChange = (center_key, event) => {
    const { name, value } = event.target;

    setCenterList((prevList) =>
      prevList.map((center) =>
        center.center_key === center_key ? { ...center, [name]: value } : center
      )
    );

    setModifiedCenters((prev) => {
      const exists = prev.find((c) => c.center_key === center_key);
      const updated = {
        ...(exists || centerList.find((c) => c.center_key === center_key)),
        [name]: value,
      };

      return exists
        ? prev.map((c) => (c.center_key === center_key ? updated : c))
        : [...prev, updated];
    });
  };

  return (
    <div className="tele-body">
      <main>
        <div className="container-fluid px-4">
          <div className="row">
            <div className="col-12 col-lg-8 col-md-8 col-sm-8 mt-2">
              <h5 className="text-blue font-roboto font-weight700">
                <small>Center Setting </small>
              </h5>
            </div>
            <div className="col-6 col-lg-2 col-md-2 col-sm-2 mt-2 mb-1">
              {/* <button
                type="button"
                className="btn btn-secondary btn-sm btn-block text-light bi bi-plus-square"
                name="Save"
                onClick={updateCenter}
              >
                {" "}
                SAVE
              </button> */}
            </div>
            <div className="col-6 col-lg-2 col-md-2 col-sm-2 mt-2 mb-1">
              <button
                type="button"
                className="btn btn-dark btn-sm btn-block text-light bi bi-x-circle"
                name="Close"
                onClick={closeClick}
              >
                {" "}
                CLOSE
              </button>
            </div>
          </div>

          <hr className="mt-0" />

          <div className="row">
            <div className="col-md-12 mb-2">
              <div className="card">
                <div className="card-header bg-gradient-1 text-light">
                  {/* Table Heading */}
                  <div className="row">
                    <div className="col-3 col-sm-1 col-md-1">
                      <p className="tele-table-heading">
                        <i
                          className="bi bi-arrow-down" /*onClick={event => sortClick(event, 'template_id') }*/
                        ></i>{" "}
                        Id{" "}
                      </p>
                      <input
                        type="text"
                        className="form-control form-control-sm tele-table-searcharea"
                        id="center_id"
                        onChange={handleSearchChange}
                        placeholder=""
                      />
                    </div>
                    <div className="col-3 col-sm-2 col-md-2">
                      <p className="tele-table-heading">
                        <i
                          className="bi bi-arrow-down icon-muted" /*onClick={event => sortClick(event, 'template_name') }*/
                        ></i>
                        Center Name
                      </p>
                      <input
                        type="text"
                        className="form-control form-control-sm tele-table-searcharea"
                        id="center_name"
                        onChange={handleSearchChange}
                        placeholder=""
                      />
                    </div>
                    <div className="col-sm-2 col-md-2 d-none d-sm-block">
                      <p className="tele-table-heading">Interval Time Gap</p>
                    </div>
                    <div className="col-sm-2 col-md-2 d-none d-sm-block">
                      <p className="tele-table-heading">
                        Default Priority Level
                      </p>
                    </div>
                    <div className="col-sm-2 col-md-2 d-none d-sm-block">
                      <p className="tele-table-heading">Default Doctor</p>
                    </div>
                  </div>
                </div>
                <div className="card-body tele-table-padding studylist-area">
                  {/* tele-table-rowbg1 */}
                  <div className="row centerlist" id="divCenterSetting"></div>
                  {(filteredCenterList.length > 0
                    ? filteredCenterList
                    : centerList
                  ).map((data, i) => (
                    <div key={i} className="row align-items-center studylist">
                      <div className="col-6 col-sm-2 col-md-1">
                        <p className="tele-table-dash-text">{data.center_id}</p>
                      </div>
                      <div className="col-6 col-sm-3 col-md-2">
                        <p className="tele-table-dash-text">{data.center_name}</p>
                      </div>
                      <div className="col-6 col-sm-2 col-md-2">
                        <p className="tele-table-dash-text">
                          {data.interval_time_gap}
                        </p>
                        {/* <input
                          type="number"
                          name="interval_time_gap"
                          value={data?.interval_time_gap ?? ""}
                          className="form-control"
                          onChange={(e) => handleChange(data.center_key, e)}
                          min={0}
                        /> */}
                      </div>
                      <div className="col-7 col-sm-2 col-md-2">
                        <p className="tele-table-dash-text">
                          {data.default_priority_level}
                        </p>
                        {/* <input
                          type="number"
                          name="default_priority_level"
                          value={data?.default_priority_level ?? ""}
                          className="form-control"
                          onChange={(e) => handleChange(data.center_key, e)}
                          min={0}
                          max={3}
                        /> */}
                      </div>

                      <div className="col-12 col-md-3 mt-2 mt-md-0">
                        <p className="tele-table-dash-text">
                          {doctorList.find(
                            (doctor) =>
                              doctor.doctor_key === data.default_doctor_key
                          )?.doctor_name || ""}
                        </p>
                        {/* <select
                          className="form-select form-select-sm w-100"
                          id="ddlDoctorList"
                          name="default_doctor_key"
                          onChange={(e) => handleChange(data.center_key, e)}
                        >
                          <option value="">Please Select Doctor</option>
                          {doctorList.map((doctor, i) => (
                            <option
                              key={i}
                              value={doctor.doctor_key}
                              selected={
                                doctor.doctor_key === data.default_doctor_key
                              }
                            >
                              {doctor.doctor_name}
                            </option>
                          ))}
                        </select> */}
                      </div>
                      <div className="col-8 col-sm-2 col-md-2">
                        <button
                          type="button"
                          className="btn btn-outline-warning btn-sm bi bi-pencil-fill m-1"
                          title="Edit Address"
                          onClick={() => handleEditAddress(data)}
                        ></button>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm bi bi-gear-fill m-1"
                          title="Edit Config"
                          onClick={() => handleEditConfig(data)}
                        ></button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {showAddressModal && (
          <CenterAddressModal
            show={showAddressModal}
            onClose={() => setShowAddressModal(false)}
            centerData={selectedCenter}
            onSave={(fields) => handleModalSave(fields, "A")}
          />
        )}
        {showConfigModal && (
          <CenterConfigModal
            show={showConfigModal}
            onClose={() => setShowConfigModal(false)}
            centerData={selectedCenter}
            doctorList={doctorList}
            onSave={(fields) => handleModalSave(fields, "C")}
          />
        )}    
      </main>
    </div>
  );
}
